import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setBeefFeedInformation, setBeefFeedInformationAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_FEED_INFORMATION } from "consts";

import { FootprintingBeefFeedInformation, UploadableBeefFeedInformation } from "models";

export const useMutateFootprintingBeefFeedInformation = (primaryDataId: string, farmId: string, year: number) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation<FootprintingBeefFeedInformation[], Error, UploadableBeefFeedInformation[]>({
    mutationKey: [FOOTPRINTING_BEEF_FEED_INFORMATION, primaryDataId, isAdmin],
    mutationFn: (data) => (isAdmin ? setBeefFeedInformationAdmin(primaryDataId, data) : setBeefFeedInformation(primaryDataId, data)),
    onSuccess: () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_BEEF_FEED_INFORMATION, primaryDataId, isAdmin],
        ...footprintingBeefPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
